import { render, staticRenderFns } from "./vwRevenuesCountItens.vue?vue&type=template&id=91e5745e&"
import script from "./vwRevenuesCountItens.vue?vue&type=script&lang=js&"
export * from "./vwRevenuesCountItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports